import { render } from "./DraftComponent.vue?vue&type=template&id=76a5212d&scoped=true"
import script from "./DraftComponent.vue?vue&type=script&lang=js"
export * from "./DraftComponent.vue?vue&type=script&lang=js"

import "./DraftComponent.vue?vue&type=style&index=0&id=76a5212d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a5212d"]])

export default __exports__